// v3.14 GHOST MODE — track best run per seed locally and race against it on replay.
// Storage shape (localStorage key: 'friendslop.ghosts.v1'):
//   { [seedUpper]: { score, floor, classId, ts } }

const GHOST_KEY = 'friendslop.ghosts.v1';

function _read() {
  try {
    const raw = localStorage.getItem(GHOST_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return (parsed && typeof parsed === 'object') ? parsed : {};
  } catch (e) {
    return {};
  }
}

function _write(map) {
  try { localStorage.setItem(GHOST_KEY, JSON.stringify(map || {})); } catch (e) { /* quota / disabled */ }
}

export function loadGhost(seed) {
  if (!seed) return null;
  const s = String(seed).toUpperCase();
  const map = _read();
  return map[s] || null;
}

// Only saves if new run outperforms previous (score first, floor as tiebreaker).
export function saveGhostIfBest(seed, { score, floor, classId }) {
  if (!seed) return false;
  const s = String(seed).toUpperCase();
  const map = _read();
  const prev = map[s];
  const newScore = Number(score) || 0;
  const newFloor = Number(floor) || 0;
  if (prev && (prev.score > newScore || (prev.score === newScore && prev.floor >= newFloor))) {
    return false;
  }
  map[s] = { score: newScore, floor: newFloor, classId: classId || null, ts: Date.now() };
  _write(map);
  return true;
}

export function clearGhost(seed) {
  const s = String(seed || '').toUpperCase();
  const map = _read();
  if (map[s]) { delete map[s]; _write(map); }
}

// Return { pace, delta } — 'ahead' | 'behind' | 'tied' | 'unknown', with numeric delta of floor - ghost.floor.
export function ghostPace(ghost, currentFloor) {
  if (!ghost) return { pace: 'unknown', delta: 0 };
  const cf = Number(currentFloor) || 0;
  const gf = Number(ghost.floor) || 0;
  if (cf > gf) return { pace: 'ahead', delta: cf - gf };
  if (cf < gf) return { pace: 'behind', delta: gf - cf };
  return { pace: 'tied', delta: 0 };
}
